import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { initTelegram } from './lib/telegram';
import { initAuth } from './lib/initAuth';

import './styles/globals.css';

// Bootstrap: сначала Telegram, потом авторизация, потом рендер
async function bootstrap() {
  initTelegram();
  await initAuth();

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

bootstrap();